module.exports = {
      id: "icon-apple-usage",
      viewBox: "0 0 13.204 15.712",
      url: "/" + "sprite-bc0169963456b1a4ad1bb8f1c406f483.svg#icon-apple",
      toString: function () {
        return this.url;
      }
    }